import axios from 'axios';
import { configAxios } from '../axiosUtils';

configAxios();

export const Auth = {
  login({ email, password }: { email: string; password: string }) {
    return axios.post('/api/login', {
      email,
      password,
    });
  },
};
